import { useCallback } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { useTranslation } = Hooks;
import { message } from "antd";
import getProductStatus from "components/Pages/Finance/_hook/getProductStatus";

export default (callback, deps) => {
  const t = useTranslation();

  const cb = useCallback(
    (productObj) => {
      const { disabled, reason } = getProductStatus(productObj);
      if (disabled && reason) {
        message.warn(t("finance.productDisabled_" + reason));
      } else {
        message.destroy();
      }
      callback && callback(productObj);
    },
    [callback, deps]
  );

  return cb;
};
